import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import type {
  DropdownProps,
  DropdownContentProps,
  DropdownTriggerProps,
  DropdownItemProps,
  DropdownLabelProps,
  DropdownSeparatorProps,
} from "./types";

function DropdownRoot({ children }: DropdownProps) {
  return <DropdownMenu.Root>{children}</DropdownMenu.Root>;
}

function DropdownTrigger({ children }: DropdownTriggerProps) {
  return <DropdownMenu.Trigger asChild>{children}</DropdownMenu.Trigger>;
}

function DropdownContent({
  children,
  side = "bottom",
  align = "start",
  sideOffset = 4,
}: DropdownContentProps) {
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        side={side}
        align={align}
        sideOffset={sideOffset}
        className="bg-card rounded-[12px] border border-border shadow-lg p-1 min-w-[180px] z-50 data-[state=open]:animate-dropdown-in data-[state=closed]:animate-dropdown-out"
      >
        {children}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  );
}

function DropdownItem({
  children,
  onSelect,
  disabled,
  destructive,
  icon,
}: DropdownItemProps) {
  return (
    <DropdownMenu.Item
      onSelect={onSelect}
      disabled={disabled}
      className={`flex items-center gap-2 px-3 py-2 text-sm rounded-[8px] cursor-pointer outline-none ${
        destructive
          ? "text-red-400 data-[highlighted]:bg-red-500/10 data-[highlighted]:text-red-300"
          : "text-secondary data-[highlighted]:bg-card-hover data-[highlighted]:text-primary"
      } data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed`}
    >
      {icon && <span className="w-4 h-4 shrink-0">{icon}</span>}
      {children}
    </DropdownMenu.Item>
  );
}

function DropdownLabel({ children }: DropdownLabelProps) {
  return (
    <DropdownMenu.Label className="px-3 py-1.5 text-xs font-medium text-muted uppercase">
      {children}
    </DropdownMenu.Label>
  );
}

function DropdownSeparator({ className }: DropdownSeparatorProps) {
  return (
    <DropdownMenu.Separator
      className={`h-px bg-border my-1 mx-2 ${className ?? ""}`}
    />
  );
}

export const Dropdown = Object.assign(DropdownRoot, {
  Trigger: DropdownTrigger,
  Content: DropdownContent,
  Item: DropdownItem,
  Label: DropdownLabel,
  Separator: DropdownSeparator,
});
